import { Pipe, PipeTransform } from '@angular/core';

import { Shipment } from '../../../pages/overview/models/shipment';

@Pipe({
  name: 'shouldShowContainerDetails',
  standalone: true
})
export class ShouldShowContainerDetailsPipe implements PipeTransform {
  transform(shipment: Shipment): boolean {
    const allowedShipmentTypes = ['FCL', 'BCN', 'BUYERS CONSOL'];
    return !!shipment.shipmentType && allowedShipmentTypes.includes(shipment.shipmentType);
  }
}
